// Core Modules
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  // Bindings
  public readonly icon = input<string>('bi-inbox');
  public readonly title = input.required<string>();
  public readonly message = input<string>('');
}
